import { Subtitle } from "chq";

import { Preview } from "@creatomate/preview";
import isSubtitleText from "./isSubtitleText";
import updateActiveSubtitleText from "./updateActiveSubtitleText";

const removeSubtitlesElements = async (
  onUpdateSubtitles: (newData: Record<string, any>) => void,
  preview: Preview,
  subtitles: Subtitle[],
  deleted?: boolean
) => {
  const activeSubtitleIndex = subtitles.findIndex(subtitle => subtitle.active);
  const activeSubtitle = subtitles[activeSubtitleIndex];

  // Remove current subtitles
  // Update source to avoid undo/redo actions here
  const source = preview.getSource();
  await preview.setSource({
    ...source,
    elements: source.elements.filter((element: any) => !isSubtitleText(element.name))
  }, false);

  if (activeSubtitle?.sections) {
    // store text changes and remove active data
    updateActiveSubtitleText(false, onUpdateSubtitles, subtitles, deleted);
  }
  onUpdateSubtitles({
    subtitles: subtitles.map(subtitle => ({ ...subtitle, deleted: subtitle.deleted || deleted }))
  });
};

export default removeSubtitlesElements;
